import { attr, BaseModel } from "../../lib/itn-ui-kit/data";

export default class EmailTemplateModel extends BaseModel {
  @attr("string") content;
  @attr("array") required;
  @attr("array") contacts;
  @attr("json") textVersion;
  @attr("json") htmlVersion;
}
